const SITE = process.env.REACT_APP_SITE_URL || 'https://javiland.com';

/** Meta SEO por `currentPage` — sitelinks: Tienda · Servicios · Growth Partner */
export const SEO_BY_PAGE = {
  home: {
    title: 'Javiland',
    description:
      'Ecosistema digital líder: creamos y administramos otros ecosistemas digitales. Holding, proyectos y servicios desde Colombia.',
    url: `${SITE}/`,
    keywords: 'javiland, ecosistema digital, holding, proyectos digitales, servicios, colombia'
  },
  proyectos: {
    title: 'Proyectos digitales',
    description:
      'Explora los ecosistemas digitales del holding Javiland: Costal, Linaje, Strutech, Meridian y más.',
    url: `${SITE}/proyectos`,
    keywords: 'proyectos digitales, holding javiland, costal, linaje, strutech, meridian'
  },
  tienda: {
    title: 'Tienda · Costal Campesino',
    description:
      'Compra despensa honesta: secos, semillas, infusiones y cacao de mesa. Envío en Colombia.',
    url: `${SITE}/tienda`,
    keywords: 'costal campesino, tienda, secos, recetas, colombia'
  },
  productos: {
    title: 'Catálogo de productos',
    description: 'Explora el catálogo completo de productos Javiland por categoría.',
    url: `${SITE}/productos`,
    keywords: 'catálogo javiland, productos naturales, tienda'
  },
  servicios: {
    title: 'Servicios y bienestar',
    description:
      'Yoga, entrenamiento consciente, Conecta tu camino y experiencias de bienestar con Javiland.',
    url: `${SITE}/servicios`,
    keywords: 'bienestar, yoga, servicios javiland, conecta tu camino'
  },
  'bienestar-yoga': {
    title: 'Yoga y meditación',
    description: 'Sesiones y programas de yoga y meditación — bienestar Javiland.',
    url: `${SITE}/bienestar/yoga`,
    keywords: 'yoga javiland, meditación, clases bienestar'
  },
  'bienestar-entrenamiento': {
    title: 'Entrenamiento consciente',
    description: 'Entrenamiento corporal y comunidad deportiva con enfoque consciente.',
    url: `${SITE}/bienestar/entrenamiento`,
    keywords: 'entrenamiento, fitness consciente, bienestar'
  },
  'bienestar-conecta': {
    title: 'Conecta tu camino',
    description: 'Programa Conecta tu camino — acompañamiento y crecimiento personal.',
    url: `${SITE}/bienestar/conecta`,
    keywords: 'conecta tu camino, crecimiento personal, bienestar'
  },
  'bienestar-reservar': {
    title: 'Reservar bienestar',
    description: 'Reserva tu sesión de bienestar con Javiland.',
    url: `${SITE}/bienestar/reservar`,
    robots: 'noindex, follow'
  },
  'growth-partner': {
    title: 'Growth Partner',
    description:
      'Alianzas digitales para marcas en Colombia: web, e-commerce y ecosistema Javiland. Strutech, tienda y más.',
    url: `${SITE}/growth-partner`,
    keywords: 'growth partner, desarrollo web colombia, ecosistema digital, javiland'
  },
  'conoce-colombia': {
    title: 'Conoce Colombia',
    description:
      'Ecoturismo consciente en Colombia: expediciones de buceo en Providencia y Gorgona, alianzas con operadores RNT y viajes personalizados.',
    url: `${SITE}/conoce-colombia`,
    keywords:
      'conoce colombia, ecoturismo colombia, buceo providencia, gorgona, viajes colombia, javiland'
  },
  contacto: {
    title: 'Contacto',
    description: 'Escríbenos — ventas, bienestar y alianzas comerciales.',
    url: `${SITE}/contacto`
  },
  comunidad: {
    title: 'Comunidad · Costal Campesino',
    description:
      'Recetas de despensa Costal Campesino: jamaica, matcha y mix campesino. Somos la tienda de tu receta.',
    url: `${SITE}/comunidad`,
    keywords: 'costal campesino, recetas, comunidad, despensa'
  },
  'costal-home': {
    title: 'Costal Campesino',
    description:
      'Despensa honesta: secos, semillas, infusiones y cacao de mesa. Somos la tienda de tu receta.',
    url: `${SITE}/costal`,
    keywords: 'costal campesino, despensa honesta, secos, recetas, colombia'
  },
  'costal-comunidad': {
    title: 'Comunidad · Costal Campesino',
    description:
      'Recetas A, B y C de Costal Campesino. Cada receta se arma completa en la tienda.',
    url: `${SITE}/comunidad`,
    keywords: 'costal campesino, recetas, jamaica, matcha, mix campesino'
  },
  'comunidad-auth': {
    title: 'Ingresar · Costal Campesino',
    description: 'Ingresá a tu cuenta Costal Campesino.',
    url: `${SITE}/comunidad/ingresar`,
    robots: 'noindex, follow'
  },
  noticias: {
    title: 'Noticias y la marca',
    description: 'Novedades, historia y propósito de Javiland.',
    url: `${SITE}/noticias`
  },
  checkout: {
    title: 'Checkout',
    description: 'Finaliza tu compra en Javiland.',
    url: `${SITE}/checkout`,
    robots: 'noindex, nofollow'
  },
  'admin-login': {
    title: 'Acceso administración',
    robots: 'noindex, nofollow'
  },
  admin: {
    title: 'Panel',
    robots: 'noindex, nofollow'
  }
};

export function getSeoForPage(page) {
  return SEO_BY_PAGE[page] || SEO_BY_PAGE.home;
}

/** Rutas públicas prioritarias para sitelinks (sitemap + navegación) */
export const SEO_SITELINK_PATHS = ['/tienda', '/servicios', '/growth-partner'];
